import { useEffect, useState, createContext, useContext } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import axios from '../../axios';

// useMutation hook
import { useMutation, useQueryClient } from '@tanstack/react-query';

// dialog for deleting
import Dialog from './Dialog';

// snackbar
import useSnackbarStore from '../../store/snackbar';

import { muiTheme } from '../theme';

import { Skeleton, IconButton, Select, MenuItem, Typography, Tooltip, CircularProgress } from '@mui/material';

import { formatDisplay, displayTruncated } from '../util';

import { IconBox } from '../Common';

import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';

import useIsMobile from '../../hooks/useIsMobile';

import handleErrors from '../errorHandler';

const DeleteMessage = styled.div`
  margin: 0 1.6rem;
`

const DeleteDialog = ({ url, id, group = false, warning_msg, toggle }) => {

  warning_msg = warning_msg ? warning_msg : <DeleteMessage>This action cannot be undone. Are you sure you want to delete this?</DeleteMessage>;
  const showSnackbar = useSnackbarStore((state) => state.showSnackbar);
  const queryClient = useQueryClient();

  const { isMobile } = useIsMobile();

  const deleteResource = async (remove_group) => {
    let remove_all = remove_group ? `?remove_group=${remove_group}` : '';
    try {
      const { data } = await axios.delete(`/${url}/${id}${remove_all}`);
      return data;
    } catch (e) {
      throw e;
    }
  }

  const { mutateAsync, isPending } = useMutation({
    mutationFn: deleteResource,
    onSuccess: () => {
      showSnackbar('Deleted successfully!', 'success');
      queryClient.invalidateQueries({ queryKey: [url] });
    },
    onError: (e) => {
      let message = handleErrors(e) || 'Failed to delete!';
      showSnackbar(message, 'error');
    }
  })

  const additionalButtons = group ?[{ text: "Delete Group", variant: "outlined", color: "secondary", func: () => mutateAsync(true)}] : [];

  return (
    <Dialog
      saveText="Confirm Delete"
      toggle={<Tooltip title="Delete">
      {toggle ? toggle : <IconBox color={muiTheme.palette.secondary.main} button size={isMobile ? "mini" : "small"} bg={muiTheme.palette.secondary.light}>
        <DeleteOutlinedIcon color="secondary" />
      </IconBox> }
    </Tooltip>}
    text={warning_msg}
    title="Confirm Delete?"
    loading={isPending}
    saveFunc={() => mutateAsync()}
    additionalButtons={additionalButtons}
    >
    </Dialog>
  )
};

export default DeleteDialog;